<template>
  <div class="vh-zalo-inbox">
    <zalo-inbox ref="inbox"></zalo-inbox>
    <div v-if="loadError" class="vh-zalo-inbox__error">{{ loadError }}</div>
  </div>
</template>

<script>
const loadedScript = require('!!file-loader?name=js/zalo-inbox.global.[hash:8].js&esModule=false!../../assets/vendor/zalo-inbox.global.js')
const inboxScript = typeof loadedScript === 'string' ? loadedScript : loadedScript.default

function loadZaloInbox(src) {
  if (window.customElements && window.customElements.get('zalo-inbox')) return Promise.resolve()
  const found = document.querySelector('script[data-zalo-inbox]')
  if (found && found.getAttribute('data-loaded')) return Promise.resolve()
  const script = found || document.createElement('script')
  if (!found) {
    script.src = src
    script.dataset.zaloInbox = '1'
    document.head.appendChild(script)
  }
  return new Promise((resolve, reject) => {
    script.addEventListener('load', () => {
      script.setAttribute('data-loaded', '1')
      resolve()
    }, { once: true })
    script.addEventListener('error', () => reject(new Error('Không tải được hộp thư Zalo')), { once: true })
  })
}

export default {
  name: 'VhZaloInbox',
  props: {
    apiBase: { type: String, required: true },
    socketBase: { type: String, required: true },
    token: { type: String, default: '' },
  },
  data: () => ({
    loadError: '',
    ready: false,
  }),
  watch: {
    apiBase: 'applyInbox',
    socketBase: 'applyInbox',
    token: 'applyInbox',
  },
  mounted() {
    loadZaloInbox(inboxScript)
      .then(() => {
        this.ready = true
        this.applyInbox()
      })
      .catch((error) => {
        this.loadError = error.message || 'Không tải được hộp thư Zalo'
      })
  },
  methods: {
    applyInbox() {
      const inbox = this.$refs.inbox
      if (!inbox || !this.ready) return
      inbox.apiBase = this.apiBase
      inbox.socketBase = this.socketBase
      inbox.token = this.token || ''
    },
  },
}
</script>

<style scoped>
.vh-zalo-inbox,
.vh-zalo-inbox zalo-inbox {
  display: block;
  height: 100%;
}
.vh-zalo-inbox { position: relative; }
.vh-zalo-inbox__error {
  position: absolute;
  left: 16px;
  right: 16px;
  top: 16px;
  color: #c62828;
}
</style>
